import { BaseFilterInput } from '../../../common-models/BaseFilterInput';
import { MarketplaceTypeEnum } from '../../../enums/MarketplaceTypeEnum';

export class GetOrderImportsInput extends BaseFilterInput {
  marketplaceType: MarketplaceTypeEnum;
}